export { useHotelDetailViewItemAnalytics } from "./useHotelDetailViewItemAnalytics";
export { useHotelDetailAddToCartAnalytics } from "./useHotelDetailAddToCartAnalytics";
export { useHotelShareAnalytics } from "./useHotelShareAnalytics";
export { buildHotelDetailSchema } from "./buildHotelDetailSchema";
